import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CONTACT_DISPLAY_AGREEMENT_COLUMNS, FILTER_CONTACT_COLUMN_LIST } from '../../constants/contact.constant';
import { contact_column_order, CONTACT_TABLE_INTERFACE } from '../../interfaces/contact.interface';
import { AppService } from 'src/app/app.service';
import { TableService } from '../../services/tableService/table.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-contact-table',
  standalone: false,
  templateUrl: './contact-table.component.html',
  styleUrl: './contact-table.component.scss'
})
export class ContactTableComponent implements OnInit, AfterViewInit {
  public contactTableForm: FormGroup = new FormGroup({});
  displayedColumns: any = CONTACT_DISPLAY_AGREEMENT_COLUMNS;
  dataSource = new MatTableDataSource<CONTACT_TABLE_INTERFACE>();
  filteredValues: any = { topFilter: false };
  actualData =new MatTableDataSource<CONTACT_TABLE_INTERFACE>();
  searchItems: any = [];
  allSelected = false;
  selectedItemforDownload=[]
  
  totalRecord = 200
  currentRecord = 10
  currentPage = 1;
  pageSize: number = 5;
  goToPageNumber: number  = 1;
  dataColList:any;
  // startIndex: number=0;
  // endIndex: number =0;

  @ViewChild(MatSort) sort: MatSort | any;
  @ViewChild(MatPaginator) paginator: MatPaginator | any;
  @ViewChild(MatSelect) matSelect!: MatSelect;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef | any;
  @ViewChild('contactType', { static: false }) contactType: ElementRef | any;
  
  selectedDate:any;
  userData: any;
  statusList = [{name:"all", active:false},{name:"Active", active:false},{name:"Not Active", active:false},{name:"Terminated", active:false}];
  createdOnDate: any;
  modifiedOnDate: any;

  constructor(public dialog: MatDialog, private fb: FormBuilder,
    public appService:AppService, public tableService:TableService) {
    // this.displayedColumns.unshift({name:'Selected', label:"Selected", selected: false, orderId:0})
    // this.displayedColumns.push({name:'action', label:"actionn", selected: false, orderId:0})   
    let userData = sessionStorage.getItem("user-data");
    this.userData = userData?JSON.parse(userData):null; 
    this.tableService.tableDataGetList('contact',this);

    this.tableService.displayColumUpdate.subscribe(obj=>{
      if(obj === "Contact"){
        this.dataColList = this.tableService.getTableColNames(this.displayedColumns)
          this.contactTableForm = this.fb.group({});          
          this.dataColList?.forEach((ele:any) => {
          this.filteredValues[ele] = '';
          this.contactTableForm.addControl(ele + "Filter", new FormControl(''));
          this.contactTableForm.get("StatusFilter")?.setValue(['Active', 'Not Active']);
          this.tableService.checkWithFilter(this)
        })
        setTimeout(() => {
          this.tableService.contactDBSOurce = this.dataSource.data
        // this.tableService.dateFromat(this)
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.tableService.checkWithFilter(this);
        },0)
      }
    })
  }

  getPageCount(): number {
    return Math.ceil(this.dataSource.data.length / this.pageSize);
  }

  onKeyDown(event: KeyboardEvent, condition=false) {
    if(condition)
      return;
    event.preventDefault();
  }

  onDateChange(e:any){
    let input = e.value;
    let formatedDate = this.formatDate(input);
    this.contactTableForm.controls[e.name].setValue(formatedDate, {emitEvent: false});
  }

  resetDateFilter(){
    this.createdOnDate= null;
    this.modifiedOnDate = null;
  }

  formatDate(date: Date): string {
    date = new Date(date)
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  onDaetChange(e:any,name:string){
    if(!e.value){
      this.contactTableForm.get(`${name}Filter`)!.setValue(undefined);
      this.dataSource.filter = "".trim().toLowerCase();
      return
    }
    if(name === 'CreatedOn'){
    this.createdOnDate = e.value;
    }
    else if(name === 'ModifiedOn'){
      this.modifiedOnDate = e.value;
    }
    const  formattedDate =this.appService.dateFormate(e.value)
    
    
    // this.contactTableForm.patchValue({[e.name]: formattedDate})
    if (this.contactTableForm.get(`${name}Filter`)) {
      this.contactTableForm.get(`${name}Filter`)!.patchValue(formattedDate);
    }
    // this.contactTableForm.get(e.name)?.setValue('kaali', { emitEvent: false });
    
    
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.pageSize = this.tableService.contactPageCount;
  }

  add(event: any): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.searchItems.push({ name: value.trim() });
    }
    if (input) {
      input.value = '';
    }
  }
  remove(item: any): void {
    const index = this.searchItems.indexOf(item);
    if (index >= 0) {
      this.searchItems.splice(index, 1);
    }
  }

  getCurrentRecordCount(): number {
    let val = this.paginator ? this.paginator?.pageIndex + 1 : 0;
    if(val*this.pageSize > this.dataSource.data.length){
      return this.dataSource.data.length%this.pageSize;
    }
    return this.pageSize;
  }
  
  onFileDownload() {
    let data =this.dataSource.data.filter(data=>data.Selected).map((item:any)=>({
      ...item,
      'CreatedOn':this.tableService.checkOnInvalidDate(item.CreatedOn),
      'ModifiedOn':this.tableService.checkOnInvalidDate(item.ModifiedOn)
    }));
    this.tableService.exportToExcel(data, contact_column_order , 'ContactTable');
   }

  //  onCalculateWIthTinme(date:any){
  //   let val = date?.split('T')[0];
  //   let tme = date?.split('T')[1].split('.')[0];
  //   let rev = val?.split('-').reverse().join('/');
  //   return rev+" "+tme
  //  }
   
   applyFilter(name:string,e:any){
    if(e.value.includes('all')){
      this.statusList.forEach((ele:any)=>{ele.active = true})
      // this.contactTableForm.get(`${name}`)!.setValue(["all","Active", "Not Active", "Terminated"]);
    }
    
   }
}


